module.exports = __webpack_public_path__ + "img/82ne.bac89bd5.svg";